import { Controller } from 'stimulus';
import Swiper from 'swiper';

class LogosSlider extends Controller {
  connect() {
    this.swiper = new Swiper(this.element, {
      slidesPerView: 2.25,
      spaceBetween: 30,
      grabCursor: true,
      autoHeight: true,
      centerInsufficientSlides: true,
      breakpoints: {
        640: {
          slidesPerView: 2.5,
        },
        800: {
          slidesPerView: 3.5,
          spaceBetween: 45,
        },
        1200: {
          slidesPerView: 5.5,
          spaceBetween: 80,
        },
      },
    });
  }
}

export default LogosSlider;
